export default __webpack_public_path__ + "static/media/75.0c9392c5.png";